import { Box } from "@mui/material"
import {
  FocusContext,
  setFocus,
  useFocusable,
} from "@noriginmedia/norigin-spatial-navigation"
import React, { useEffect } from "react"

import { DGText } from "../../../components/common/DGText"
import useTranslate, { Namespaces } from "../../../hooks/use-translate"
import { s } from "../../../utilities/common"
import { theme, TI } from "../../../utilities/theme"
import { OnboardingFocusKeys } from "../components/onboarding-focus-keys"
import { OnboardingButton } from "../components/OnboardingButton"
import { SlideIndex } from "../OnboardingScreen"

export const Slide1 = ({
  nextSlideAction,
}: {
  nextSlideAction: React.Dispatch<React.SetStateAction<SlideIndex>>
}) => {
  const t = useTranslate()
  const t_common = useTranslate(Namespaces.Common)
  const { ref, focusKey } = useFocusable({
    isFocusBoundary: true,
  })

  useEffect(() => {
    setFocus(OnboardingFocusKeys.Default)
  }, [])

  return (
    <FocusContext.Provider value={focusKey}>
      <Box
        ref={ref}
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          zIndex: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
            width: s("1000px"),
            alignItems: "center",
          }}
        >
          <DGText
            tx={TI.H05tv}
            aria-hidden={true}
            sx={{
              color: theme.palette.white.main,
              mb: s("24px"),
            }}
          >
            {t_common("toast__congrats_create_title")}
          </DGText>
          <DGText
            tx={TI.Subheadline05tv}
            aria-hidden={true}
            sx={{
              color: theme.palette.white.main,
            }}
          >
            {t("onboarding__welcome_text")}
          </DGText>
          <OnboardingButton
            ariaLabel={`${t("onboarding__welcome_text")}. ${t("onboarding__button_next")}`}
            sx={{
              mt: s("70px"),
              width: s("117px"),
              height: s("80px"),
              pr: 0,
              pl: 0,
            }}
            onEnterPress={() => nextSlideAction(2)}
            focusKey={OnboardingFocusKeys.Default}
            text={t("onboarding__button_next")}
          />
        </Box>
      </Box>
    </FocusContext.Provider>
  )
}
